import { useEffect } from 'react';
import type { AchievementCheckData } from '../achievements/achievementData';
import { STANDALONE_COSMETIC_GATES } from '../useDjayCustomization';
import { TREATMENT_GATES } from '../useTreatmentUnlocks';

/**
 * usePersistUnlockedCosmetics — mascot-domain side-effect that persists a
 * standalone cosmetic / treatment finish the moment its live stat gate is first
 * met, so it stays "owned" even if the underlying stat later dips (e.g. weekly
 * counters resetting on a new week).
 *
 * DDD note: this persistence logic previously lived inline in
 * `components/collection/CollectionPage.tsx`, which meant a cosmetic only got
 * persisted while the Collection page happened to be mounted. Extracting it into
 * the mascot domain keeps the unlock-persistence concern out of the UI and lets
 * any stable host drive it. The page still calls it today; a future move to an
 * always-mounted learner host will close the "only persists when the locker is
 * open" gap without touching this contract.
 *
 * Idempotent: `markCosmeticUnlocked` no-ops on duplicates. Treatment gates are
 * cumulative (labSessionsCompleted only grows) but are persisted through the
 * same path for consistency with the SSOT.
 */
export function usePersistUnlockedCosmetics(checkData: AchievementCheckData, unlockedCosmetics: string[], markCosmeticUnlocked: (cosmeticId: string) => void): void {
  useEffect(() => {
    ;
    [...STANDALONE_COSMETIC_GATES, ...TREATMENT_GATES].forEach(gate => {
      if (gate.isMet(checkData) && !unlockedCosmetics.includes(gate.id)) {
        markCosmeticUnlocked(gate.id);
      }
    });
  }, [checkData, unlockedCosmetics, markCosmeticUnlocked]);
}